<script>
    import CRUD from './CRUD.svelte';
    import { onMount } from 'svelte';
    import { t } from 'svelte-i18n';
    import { fetchImpuestoPlantillas, saveImpuestoPlantilla, removeImpuestoPlantilla, searchImpuestoPlantillas, subscribeToImpuestoPlantillas, unsubscribeFromImpuestoPlantillas } from '../controllers/impuestoPlantillaController.js';

    let impuestoPlantillaColumns = [
        { label: $t('fields.description'), field: 'descrip', type: 'text' },
        { label: $t('fields.state'), field: 'sta', type: 'bool' },
    ];

    let newImpuestoPlantilla = {
        descrip: '',
        sta: true,
    };

    let editColumns = [
        { label: $t('fields.description'), key: 'descrip', type: 'text', required: true },
        { label: $t('fields.state'), key: 'sta', type: 'checkbox' },
    ];
</script>

<CRUD 
    title={$t('entities.impuestos')}
    entityName="impuesto_plantilla"
    newEntity={newImpuestoPlantilla}
    columns={impuestoPlantillaColumns}
    fetchEntities={fetchImpuestoPlantillas}
    saveEntity={saveImpuestoPlantilla}
    removeEntity={removeImpuestoPlantilla}
    searchEntities={searchImpuestoPlantillas}
    subscribeToChanges={subscribeToImpuestoPlantillas}
    unsubscribeFromChanges={unsubscribeFromImpuestoPlantillas}
    editColumns={editColumns}
/>